<template>
  <div class="registerCardStyle">
    <div class="registerBase">
      <UserBase
        :title="$t('user.user_account-creation')"
        :isRegister="true"
        :minWidth="minWidth"
      >
        <template #default>
          <v-row
            no-gutters
            class="pb-2"
            justify="center"
            align-content="center"
          >
            <v-col cols="10">
              <v-text-field
                v-model="userInfo.mail"
                :placeholder="$t('common.input_mailaddress')"
                :rules="validations.mail.rules"
                type="email"
                outlined
                dense
                :hide-details="!isShowErrorMessage('mail')"
                height="36"
                @blur="validations.mail.isInput = true"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="py-2"
            justify="center"
            align-content="center"
          >
            <v-col cols="10">
              <v-text-field
                v-model="userInfo.password1"
                :placeholder="$t('common.input_password')"
                :rules="validations.password1.rules"
                type="password"
                outlined
                dense
                :hide-details="!isShowErrorMessage('password1')"
                height="36"
                @blur="validations.password1.isInput = true"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="py-2"
            justify="center"
            align-content="center"
          >
            <v-col cols="10">
              <v-text-field
                v-model="userInfo.password2"
                :placeholder="$t('user.user_password-for-confirm')"
                :rules="validations.password2.rules"
                type="password"
                outlined
                dense
                :hide-details="!isShowErrorMessage('password2')"
                height="36"
                @blur="validations.password2.isInput = true"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="py-3"
            justify="center"
            align-content="center"
          >
            <v-col cols="1">
              <v-checkbox class="ma-0" v-model="userInfo.agree" />
            </v-col>
            <v-col cols="9" class="termsStyle">
              <span class="terms">
                <a
                  class="text-decoration-underline"
                  color="linkText--text"
                  @click="onClickTerms"
                  >{{ $t('common.common_term-of-service') }}</a
                >
                、
                <a
                  class="text-decoration-underline"
                  color="linkText--text"
                  @click="onClickPrivacy"
                  >{{ $t('common.common_privacy-policy') }}</a
                >
                {{ $t('user.user_confirm-and-agree') }}
              </span>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align-content="center">
            <v-col cols="10">
              <NormalButton
                :text="$t('common.input_order-send')"
                height="50px"
                :disabled="isDisabledExecButton"
                @click="execRegisterUser"
              />
            </v-col>
          </v-row>
        </template>
      </UserBase>
      <TermsDialog v-model="dialogParams" />
      <LandingPage />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { UserBase } from '@/components/layouts'
import { NormalButton } from '@/components/items'
import { TermsDialog } from '@/components/layouts/Dialogs'
import LandingPage from '@/components/LandingPage.vue'

const regexp =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/ // eslint-disable-line

export default {
  components: {
    UserBase,
    NormalButton,
    TermsDialog,
    LandingPage
  },
  data: () => {
    return {
      isError: false,
      validations: {
        mail: { isInput: false, rules: [] },
        password1: { isInput: false, rules: [] },
        password2: { isInput: false, rules: [] }
      },
      userInfo: {
        mail: '',
        password1: '',
        password2: '',
        agree: false
      },
      isFetching: false,
      dialogParams: {
        dialog: false,
        type: 'TERMS'
      },
      minWidth: 360
    }
  },
  created() {
    this.makeValidationRules()
  },
  computed: {
    isVaridationsError() {
      return (
        this.isShowErrorMessage('mail') ||
        this.isShowErrorMessage('password1') ||
        this.isShowErrorMessage('password2')
      )
    },
    isDisabledExecButton() {
      if (this.isFetching) {
        return true
      }
      if (this.isVaridationsError) {
        return true
      }
      if (!this.userInfo.agree) {
        return true
      }
      if (
        !this.userInfo.mail ||
        !this.userInfo.password1 ||
        !this.userInfo.password2
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('User', ['registerUser']),
    onClickTerms() {
      this.dialogParams.type = 'TERMS'
      this.dialogParams.dialog = true
    },
    onClickPrivacy() {
      this.dialogParams.type = 'PRIVACY'
      this.dialogParams.dialog = true
    },
    async execRegisterUser() {
      this.isFetching = true
      const isSucceed = await this.registerUser({
        email: this.userInfo.mail,
        password: this.userInfo.password1,
        password_confirmation: this.userInfo.password2
      })
      this.isFetching = false
      if (isSucceed) {
        this.$router.push({
          name: 'user.register.success'
        })
      }
    },
    checkPasswordVarid(str) {
      const ratz = /[a-z]/,
        rAtZ = /[A-Z]/,
        r0t9 = /[0-9]/
      return (
        ratz.test(str) && rAtZ.test(str) && r0t9.test(str) && str.length > 7
      )
    },
    checkPasswordMatch() {
      return this.userInfo.password1 === this.userInfo.password2
    },
    isShowErrorMessage(type) {
      const targetRule = this.validations[type]
      switch (type) {
        case 'mail':
          return (
            targetRule.isInput &&
            (!this.userInfo.mail || !regexp.test(this.userInfo.mail))
          )
        case 'password1':
          return (
            targetRule.isInput &&
            (!this.userInfo.password1 ||
              !this.checkPasswordVarid(this.userInfo.password1))
          )
        case 'password2':
          return (
            targetRule.isInput &&
            (!this.userInfo.password2 ||
              !this.checkPasswordVarid(this.userInfo.password2) ||
              !this.checkPasswordMatch())
          )
        default:
          return
      }
    },
    makeValidationRules() {
      this.validations.mail.rules = [
        (v) => v.length > 0 || this.$t('common.common_is-required'),
        (v) => regexp.test(v) || this.$t('common.common_is-email')
      ]
      this.validations.password1.rules = [
        (v) => v.length > 0 || this.$t('common.common_is-required'),
        (v) =>
          this.checkPasswordVarid(v) || this.$t('common.common_is-password')
      ]
      this.validations.password2.rules = [
        (v) => v.length > 0 || this.$t('common.common_is-required'),
        (v) =>
          this.checkPasswordVarid(v) || this.$t('common.common_is-password'),
        () =>
          this.checkPasswordMatch() ||
          this.$t('common.common_confirm-password-different')
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.registerCardStyle {
  .terms {
    font-size: 12px !important;
  }
  .registerBase {
    display: flex;
    flex-direction: row-reverse;
  }
}
</style>
